import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import {
  START_IMPORT_CSV,
  RESET_PATIENT_STATE,
} from "../../Actions/PatientAction";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { DropzoneArea } from "mui-file-dropzone";
import ImportSurgeryDialog from "./ImportSurgeryDialog";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import { FileTypeItems, importType, statusMenuItems } from "../../utils/data";
import AutoCompleteTextField from "../../Components/Common/AutoCompleteTextField";
import { useNotification } from "../../Hooks/NotificationManager";
import InfoIcon from "../../Assets/Icons/IInfo.png";
import { ReactComponent as ManPlusIcon } from "../../Assets/Icons/ManPlusIcon.svg";
import { ReactComponent as uploadIcon } from "../../Assets/Icons/uploadIcon.svg";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import ImportTypeDialog from "./ImportTypeDialog";
import { ReactComponent as ExcelIcon } from "../../Assets/Icons/ExcelIcon.svg";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      padding: "7.5px 108px 7.5px 6px !important",
    },
  },
  rsUploadBtn: {
    display: "flex !important",
    margin: "0px 0px !important",
    width: "400px !important",
    height: "133px !important",
    backgroundColor: `${theme.palette.white.main} !important`,
    color: `${theme.palette.background.black} !important`,
  },
  rsErrorText: {
    color: theme.palette.background.red,
    // textAlign: "center",
    marginTop: "10px",
    fontSize: "13px",
  },
  preview: {
    display: "none",
  },
  dropZone: {
    minHeight: "185px !important",
    maxHeight: "100px",
    width: "98% !important",
    margin: "0px 0px",
    borderColor: "#7bc0448f !important",
    borderRadius: "4px",
    borderWidth: "thin !important",
    // backgroundColor: "#7bc04414 !important",
    backgroundColor: "#7bc0440d !important",
    "& .MuiSvgIcon-root": {
      color: "hsl(240deg 7% 62%)",
    },
    "& .MuiTypography-root": {
      marginBottom: "5px",
      color: "black",
    },
    "&>div": {
      display: "flex",
      flexDirection: "column-reverse",
      justifyContent: "center",
      alignItems: "center",
      height: "183px",
      "&>p": {
        margin: "0px",
        fontSize: "20px !important",
      },
      "&>svg": {
        // marginTop: "25px",
        height: "60px",
      },
    },
  },
  dropzoneShowAttachFit: {
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiSvgIcon-root": {
      color: "black",
    },
  },
  dropzoneShowAttachFitClick: {
    pointerEvents: "none",
    cursor: "default",
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiSvgIcon-root": {
      color: "black",
    },
  },
  droperMain: {
    width: "98%",
  },
  seeMore: {
    paddingLeft: "0px",
    paddingTop: "10px",
    justifyContent: "start",
    alignItems: "center",
    width: "98%",
    display: "flex",
    "&>img": {
      width: "30px",
      height: "30px",
      marginLeft: "-10px !important",
    },
    "&>h5": {
      fontSize: "16px !important",
      color: "black !important",
      textDecoration: "underline !important",
      cursor: "pointer",
      [theme.breakpoints.down("490")]: {
        fontSize: "13px !important",
      },
    },
  },
  seeMoresmall: {
    paddingLeft: "0px",
    paddingTop: "10px",
    justifyContent: "start",
    alignItems: "center",
    width: "98%",
    display: "flex",
    "&>img": {
      width: "25px",
      height: "25px",
    },
    "&>h5": {
      fontSize: "12px !important",
      color: "black !important",
      textDecoration: "underline !important",
      cursor: "pointer",
    },
  },

  rsDropper: {
    display: "flex",
    justifyContent: "center",
    width: "98%",
  },
  dropperMain: {
    display: "flex",
    flexDirection: "column",
  },
  DailogContainer: {
    "&>div": {
      "&>div": {
        height: "570px",
        maxWidth: "570px",
        borderRadius: "15px",
        "@media (max-height: 667px)": {
          marginTop: "-45px !important",
        },
        "&>form": {
          "& > div:first-child": {
            height: "380px",
          },
        },
      },
    },
  },
  Iconimage: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
  },
  primaryTitle: {
    background: "red",
  },
  subTitle: {
    fontSize: "15px",
  },
}));

function ImportCsvPatientDialog({
  open,
  setOpen,
  importCsvAction,
  importPatientCsv,
  getImportCsvListAction,
  resetPatientState,
  loginUserDetail,
  subscriptionDialog,
  setSubscriptionDialog,
}) {
  const classes = useStyles();
  const [file1, setFile1] = useState("");
  const [file2, setFile2] = useState("");
  const [fileRXtitan, setFileRXtitan] = useState([]);
  const [randomKey, setRandomKey] = useState(Math.random());
  const [fileError, setFileError] = useState(false);
  const [fileError2, setFileError2] = useState(false);
  const [fileTypeError, setFileTypeError] = useState(false);
  const [errorValidation, setErrorValidation] = useState("");
  const [errorValidation2, setErrorValidation2] = useState("");
  const [surgeryDilaog, setSurgeryDilaog] = useState(false);
  const [surgeryData, setSurgeryData] = useState([]);
  const [surgerySubmit, setSurgerySubmit] = useState(false);
  const [openPermission, setOpenPermission] = useState(false);
  const [isOpenStatusList, setIsOpenStatusList] = useState(false);
  const [importTypeDiloag, setImportTypeDiloag] = useState(false);
  const [docLink, setDocLink] = useState("");
  const notification = useNotification();
  const [fileType, setFileType] = useState({
    value: "proscript",
    label: "Proscript",
  });
  /** handle close */
  const handleClose = () => {
    setOpen(false);
    setFileError(false);
    setFileError2(false);
    setFile1("");
    setFile2("");
    setErrorValidation("");
    setErrorValidation2("");
    setFileType({
      value: "proscript",
      label: "Proscript",
    });
  };
  const handleChange = (e) => {
    setErrorValidation("");
    setErrorValidation2("");
    const file = e[0];
    setFile1("");
    if (file === undefined) {
      setFile1("");
      return false;
    }
    if (file) {
      if (
        [
          "text/csv",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].indexOf(file?.type) === -1
      ) {
        file = "";
        setFileTypeError(true);
        return;
      } else {
        if (file) {
          setFile1(e[0]);
        }
      }
    }
  };
  const handleChangefile = (e) => {
    setErrorValidation("");
    setErrorValidation2("");
    const file = e[0];
    setFile2("");
    if (file === undefined) {
      setFile2("");
      return false;
    }
    if (file) {
      if (
        [
          "text/csv",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].indexOf(file?.type) === -1
      ) {
        file = "";
        setFileTypeError(true);
        return;
      } else {
        if (file) {
          setFile2(e[0]);
        }
      }
    }
  };
  /* File Import Function */
  const handleSubmitFile = (event) => {
    event.preventDefault();

    if (fileType?.value == "titan" || fileType?.value == "rxweb") {
      if (file1 === "") {
        setFileError(true);
      }
      if (file2 === "") {
        setFileError2(true);
      }
      if (file2 !== "" && file2 !== "") {
        const formData = new FormData();
        formData.append("upload_file", file1);
        formData.append("upload_file2", file2);
        formData.append("is_create_surgery", true);
        formData.append("import_type", fileType?.value);
        importCsvAction(formData);
      }
    } else {
      if (file1 === "") {
        setFileError(true);
      } else {
        const formData = new FormData();
        formData.append("upload_file", file1);
        formData.append("is_create_surgery", true);
        formData.append("import_type", fileType?.value);
        importCsvAction(formData);
      }
    }
  };

  /** Success useEffect & reset reducer State */
  useEffect(() => {
    if (
      !importPatientCsv?.loading &&
      Object.keys(importPatientCsv?.data || {})?.length > 0 &&
      surgerySubmit === false
    ) {
      // handleClose();
      // resetPatientState("importPatientCsv", "");
    }
  }, [importPatientCsv]);

  /* Success after close popup & list api data show */
  useEffect(() => {
    if (importPatientCsv?.data?.success === true) {
      if (
        importPatientCsv?.data?.data?.surgery !== undefined &&
        surgerySubmit === false
      ) {
        setSurgeryDilaog(true);
        setSurgeryData(importPatientCsv?.data?.data?.surgery);
      } else {
        handleClose();
        getImportCsvListAction();
        resetPatientState("importPatientCsv", "");
      }
    }
  }, [importPatientCsv?.data?.success]);

  useEffect(() => {
    if (loginUserDetail?.data?.data?.is_expired) {
      if (
        importPatientCsv?.error?.message?.data?.message ===
          "You don't have permission because your subscription has expired. Please contact your pharmacy." &&
        openPermission
      ) {
        setSubscriptionDialog(true);
        setOpenPermission(false);
      }
    }
    const errors = importPatientCsv?.error?.data?.errors["upload_file"];
    const errors2 = importPatientCsv?.error?.data?.errors["upload_file2"];
    setErrorValidation(errors);
    setErrorValidation2(errors2);
    if (importPatientCsv?.error?.message?.data?.message) {
      notification.error(importPatientCsv?.error?.message?.data?.message);
    }
  }, [importPatientCsv?.error]);
  const handleImportFile = () => {
    const formData = new FormData();
    formData.append("upload_file", file1);
    if (file2) {
      formData.append("upload_file2", file2);
    }
    formData.append("import_type", fileType?.value);
    importCsvAction(formData);
    setSurgeryDilaog(false);
    setSurgerySubmit(false);
  };
  const handleOpenhowTo = () => {
    setImportTypeDiloag(true);
    importType.map((item) => {
      if (item.key == fileType?.value) {
        setDocLink(item?.link);
      }
    });
  };
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.DailogContainer}
      >
        <Box className={classes.Iconimage}>
          <PrimaryIcon height="35px" icon={ManPlusIcon} />

          <PrimaryDialogTitle
            handleClose={handleClose}
            title="Import Patient"
          />
        </Box>
        <form onSubmit={handleSubmitFile}>
          <DialogContent>
            <Box style={{ padding: "0px 30px" }}>
              <Grid container columnSpacing={0.5} rowSpacing={2}>
                <Grid
                  item
                  xs={12}
                  justifyContent={"center"}
                  display={"flex"}
                  marginLeft={"-5px"}
                >
                  <AutoCompleteTextField
                    disableClearable={true}
                    className={classes.droperMain}
                    value={fileType}
                    open={isOpenStatusList}
                    onOpen={() => {
                      setIsOpenStatusList(true);
                    }}
                    onClose={() => {
                      setIsOpenStatusList(false);
                    }}
                    options={FileTypeItems}
                    getOptionLabel={(option) => option.label}
                    filterOptions={(option) => {
                      let result = [...option];
                      return result || [];
                    }}
                    onChange={(e, value) => {
                      setFile1("");
                      setFile2("");
                      setIsOpenStatusList(false);
                      setFileType(value || "");
                    }}
                    placeholder="Choose your PMR system *"
                    label="Choose your PMR system *"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", gap: "10px" }}
                  className={classes.rsDropper}
                >
                  <Grid
                    item
                    xs={
                      fileType?.value == "proscript" || fileType?.value == "mps"
                        ? 12
                        : 6
                    }
                  >
                    <Box className={classes.dropperMain}>
                      <DropzoneArea
                        maxFileSize={20000000}
                        dropzoneProps={
                          importPatientCsv?.loading
                            ? { disabled: true }
                            : { disabled: false }
                        }
                        key={randomKey}
                        dropzoneClass={`${classes.dropZone} ${
                          !!file1 ? classes.dropzoneShowAttachFit : ""
                        }
                 ${
                   importPatientCsv?.loading
                     ? classes.dropzoneShowAttachFitClick
                     : ""
                 }
                  `}
                        filesLimit={
                          fileType?.value == "default" ||
                          fileType?.value == "proscript" ||
                          fileType?.value == "mps"
                            ? 1
                            : 1
                        }
                        clearOnUnmount={true}
                        onChange={handleChange}
                        showPreviewsInDropzone={
                          file1 !== "" && file1 !== undefined ? true : false
                        }
                        Icon={ExcelIcon}
                        dropzoneText={
                          file1 && file1.name ? (
                            file1.name
                          ) : fileType?.value === "default" ||
                            fileType?.value === "proscript" ||
                            fileType?.value == "mps" ? (
                            "Upload excel file"
                          ) : (
                            <div>
                              <Typography>
                                Upload excel file{" "}
                                <span style={{ fontWeight: "500" }}>A</span>
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "100",
                                }}
                              >
                                Only XLSX, CSV and XLS
                              </Typography>
                            </div>
                          )
                        }
                        showAlerts={false}
                        acceptedFiles={[
                          // "text/csv",
                          "application/vnd.ms-excel",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]}
                        previewGridClasses={{
                          container: classes.previewContainer,
                          item: classes.preview,
                        }}
                        previewGridProps={{
                          container: { spacing: 0, direction: "row" },
                        }}
                      />
                      {/* {fileError === true ? (
                        <Box className={classes.rsErrorText}>
                          The upload file field is required.
                        </Box>
                      ) : (
                        ""
                      )} */}
                      {fileError === true && !file1?.name && (
                        <Box className={classes.rsErrorText}>
                          The upload file field is required.
                        </Box>
                      )}
                      {fileTypeError === true && !file1?.name && (
                        <Box className={classes.rsErrorText}>
                          The file must be a file of type: .CSV
                        </Box>
                      )}
                      {errorValidation && (
                        <Box className={classes.rsErrorText}>
                          {errorValidation}
                        </Box>
                      )}
                      <Box
                        className={
                          fileType?.value == "titan" ||
                          fileType?.value == "rxweb"
                            ? classes.seeMoresmall
                            : classes.seeMore
                        }
                      >
                        <img src={InfoIcon} />
                        <Typography
                          variant="h5"
                          onClick={() => {
                            handleOpenhowTo();
                          }}
                        >
                          {fileType?.value == "titan" ||
                          fileType?.value == "rxweb"
                            ? `See how to create ${
                                fileType?.value == "titan"
                                  ? "Titan"
                                  : fileType?.value == "rxweb"
                                  ? "RxWeb"
                                  : fileType?.value == "mps"
                                  ? "MPS"
                                  : "Proscript"
                              } file A?`
                            : `See how to create  ${
                                fileType?.value == "titan"
                                  ? "Titan"
                                  : fileType?.value == "rxweb"
                                  ? "RxWeb"
                                  : fileType?.value == "mps"
                                  ? "MPS"
                                  : "Proscript"
                              } file ?`}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  {(fileType?.value == "titan" ||
                    fileType?.value == "rxweb") && (
                    <Grid item xs={6}>
                      <Box className={classes.dropperMain}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          dropzoneProps={
                            importPatientCsv?.loading
                              ? { disabled: true }
                              : { disabled: false }
                          }
                          key={randomKey}
                          dropzoneClass={`${classes.dropZone} ${
                            !!file2 ? classes.dropzoneShowAttachFit : ""
                          }
                 ${
                   importPatientCsv?.loading
                     ? classes.dropzoneShowAttachFitClick
                     : ""
                 }
                  `}
                          filesLimit={
                            fileType?.value == "default" ||
                            fileType?.value == "proscript" ||
                            fileType?.value == "mps"
                              ? 1
                              : 1
                          }
                          clearOnUnmount={true}
                          onChange={handleChangefile}
                          showPreviewsInDropzone={
                            file2 !== "" && file2 !== undefined ? true : false
                          }
                          Icon={ExcelIcon}
                          dropzoneText={
                            file2 && file2.name ? (
                              file2.name
                            ) : fileType?.value === "default" ||
                              fileType?.value === "proscript" ||
                              fileType?.value == "mps" ? (
                              "Upload excel file"
                            ) : (
                              <div>
                                <Typography>
                                  Upload excel file{" "}
                                  <span style={{ fontWeight: "500" }}>B</span>
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "100",
                                  }}
                                >
                                  Only XLSX, CSV and XLS
                                </Typography>
                              </div>
                            )
                          }
                          showAlerts={false}
                          acceptedFiles={[
                            // "text/csv",
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          ]}
                          previewGridClasses={{
                            container: classes.previewContainer,
                            item: classes.preview,
                          }}
                          previewGridProps={{
                            container: { spacing: 0, direction: "row" },
                          }}
                        />
                        {/* {fileError2 === true ? (
                          <Box className={classes.rsErrorText}>
                            The upload file field is required.
                          </Box>
                        ) : (
                          ""
                        )} */}
                        {fileError2 === true && !file2?.name && (
                          <Box className={classes.rsErrorText}>
                            The upload file field is required.
                          </Box>
                        )}
                        {fileTypeError === true && !file2?.name && (
                          <Box className={classes.rsErrorText}>
                            The file must be a file of type: .CSV
                          </Box>
                        )}
                        {errorValidation2 && (
                          <Box className={classes.rsErrorText}>
                            {errorValidation2}
                          </Box>
                        )}

                        <Box
                          className={
                            fileType?.value == "titan" ||
                            fileType?.value == "rxweb"
                              ? classes.seeMoresmall
                              : classes.seeMore
                          }
                        >
                          <img src={InfoIcon} />
                          <Typography
                            variant="h5"
                            onClick={() => {
                              handleOpenhowTo();
                            }}
                          >
                            {fileType?.value == "titan" ||
                            fileType?.value == "rxweb"
                              ? `See how to create ${
                                  fileType?.value == "titan"
                                    ? "Titan"
                                    : fileType?.value == "rxweb"
                                    ? "RxWeb"
                                    : "Proscript"
                                } file B?`
                              : `See how to create  ${
                                  fileType?.value == "titan"
                                    ? "Titan"
                                    : fileType?.value == "rxweb"
                                    ? "RxWeb"
                                    : "Proscript"
                                } file ?`}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions className={classes.rsPatientAddMed}>
            <Button
              variant="contained"
              type="submit"
              className={classes.rsPatientBtn}
              disabled={importPatientCsv?.loading}
              startIcon={
                importPatientCsv?.loading && (
                  <CircularProgress color="white" size="20px" />
                )
              }
            >
              <PrimaryIcon
                style={{ height: "35px", marginRight: "10px" }}
                icon={uploadIcon}
              />
              Upload file
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <ImportSurgeryDialog
        open={surgeryDilaog}
        setOpen={setSurgeryDilaog}
        surgeryData={surgeryData}
        handleClose={handleImportFile}
        surgerySubmit={surgerySubmit}
        setSurgerySubmit={setSurgerySubmit}
        fileType={fileType}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscriptionDialog}
      />
      <ImportTypeDialog
        link={docLink}
        open={importTypeDiloag}
        setOpen={setImportTypeDiloag}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  importPatientCsv: state.patient.importPatientCsv,
});

const mapDispatchToProps = (dispatch) => ({
  importCsvAction: (formData) => dispatch({ type: START_IMPORT_CSV, formData }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportCsvPatientDialog);
